import React, { FC } from 'react';
import { TypographyTagVariants } from '@components/atoms/Typography';
import { Card } from '@components/atoms/Card';

export interface ResumedStatisticCardProps {
    title: string;
}

export const ChartCard: FC<ResumedStatisticCardProps> = ({ title }) => {
    return (
        <Card>
            <div className="card-body p-3 p-md-4 m-md-2">
                <Card.Title
                    typography={{
                        tagVariant: TypographyTagVariants.h5,
                        classes: 'mb-2',
                        fontWeight: '400',
                        fontSize: '16',
                        breakpointsStyles: { md: { fontSize: '20' } },
                        children: title,
                    }}
                />
                {/* TODO: chart */}
                (#TODO: chart)
            </div>
        </Card>
    );
};
